import { render, staticRenderFns } from "./AssayView.vue?vue&type=template&id=f8c67b7e&scoped=true"
import script from "./AssayView.vue?vue&type=script&lang=js"
export * from "./AssayView.vue?vue&type=script&lang=js"
import style0 from "./AssayView.vue?vue&type=style&index=0&id=f8c67b7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c67b7e",
  null
  
)

export default component.exports